module.exports = __webpack_public_path__ + "static/convention_bn@2x-7411f066669dafd70c1f418960546380.png";